import { StyledBorderButton, StyledButton } from "@components";
import { ICustomerDetail } from "@interfaces";
import { PATH_MY_ACCOUNT } from "@routes";
import { breakpoint, theme } from "@utilities";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import styled, { keyframes } from "styled-components";

export interface Suggestion {
    first_name: string | null;
    last_name: string | null;
    phone_number: number;
    country_code: string;
    email: string;
    id: string;
}

interface TravellerSuggestionsBottomSheetProps {
    isOpen: boolean;
    onClose: () => void;
    suggestions: ICustomerDetail[];
    selectedSuggestion: Suggestion | null;
    onSelect: (suggestion: Suggestion) => void;
    onAdd: () => void;
    onCreateNew: () => void;
    countriesData: any[];
    isAccountIncomplete: boolean;
}
interface StyledSuggestionButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    isSuggestionClicked: boolean;
    disabled?: boolean;
}

export const TravellerSugesstionBoxDesktopView = ({
    isOpen,
    onClose,
    suggestions,
    selectedSuggestion,
    onSelect,
    onAdd,
    onCreateNew,
    countriesData,
    isAccountIncomplete,
}: TravellerSuggestionsBottomSheetProps) => {
    if (!isOpen) return null;

    const getCountryName = (targetCode: string | undefined) =>
        _.get(_.find(countriesData, { countryCode: targetCode }), "name", "Not Found");
    const navigate = useNavigate();

    return (
        <TravellerPopup onClick={onClose}>
            <Popup onClick={(e) => e.stopPropagation()}>
                {isAccountIncomplete ? (
                    <PopupContent>
                        <h2>
                            Your personal details <br /> are missing
                        </h2>
                        <p>
                            You haven't entered your personal details yet.
                            <br />
                            <span style={{ display: "block", marginTop: "10px" }}>
                                Please fill them in to proceed.
                            </span>
                        </p>
                        <div className="styled-buttons">
                            <StyledButton
                                $borderRadius="4px"
                                color={["#436CB2 0%", "#28B7C3 100%"]}
                                onClick={() => navigate(PATH_MY_ACCOUNT)}
                            >
                                Add my personal details
                            </StyledButton>
                            <BorderButton
                                onClick={onClose}
                                $borderRadius="4px"
                                color="transparent"
                                $textColor={theme.colors.main}
                            >
                                Cancel
                            </BorderButton>
                        </div>
                    </PopupContent>
                ) : (
                    <SuggesstionPopup>
                        <div className="details-container-web">
                            <h2>Suggestions</h2>
                            <ScrollBox>
                                {_.map(suggestions, (user) => (
                                    <div className="details" key={user.id}>
                                        <span>
                                            <StyledSuggestionButton
                                                type="button"
                                                isSuggestionClicked={
                                                    selectedSuggestion?.id === user.id
                                                }
                                                onClick={() =>
                                                    onSelect({
                                                        first_name: user.first_name,
                                                        last_name: user.last_name,
                                                        phone_number: Number(user.phone_number),
                                                        country_code: user.country_code,
                                                        email: user.email,
                                                        id: user.id,
                                                    })
                                                }
                                            >
                                                <div />
                                            </StyledSuggestionButton>
                                        </span>
                                        <div>
                                            <h1>
                                                {user.first_name} {user.last_name}{" "}
                                                {user.is_primary === 1 && "(you)"}
                                            </h1>
                                            <p>
                                                {user.phone_number},{" "}
                                                {getCountryName(user.country_code)}, {user.email}
                                            </p>
                                        </div>
                                    </div>
                                ))}
                            </ScrollBox>
                        </div>
                        <div className="styled-buttons">
                            <BorderButton
                                $borderRadius="4px"
                                color="transparent"
                                $textColor={theme.colors.main}
                                onClick={onCreateNew}
                            >
                                Create New
                            </BorderButton>
                            <NormalStyledButton
                                $borderRadius="4px"
                                color={["#436CB2 0%", "#28B7C3 100%"]}
                                onClick={onAdd}
                            >
                                Add to booking
                            </NormalStyledButton>
                        </div>
                    </SuggesstionPopup>
                )}
            </Popup>
        </TravellerPopup>
    );
};

export const TravellerSuggestionsBox = ({
    isOpen,
    onClose,
    suggestions,
    selectedSuggestion,
    onSelect,
    onAdd,
    onCreateNew,
    countriesData,
    isAccountIncomplete,
}: TravellerSuggestionsBottomSheetProps) => {
    if (!isOpen) return null;

    const getCountryName = (targetCode: string | undefined) =>
        _.get(_.find(countriesData, { countryCode: targetCode }), "name", "Not Found");
    const navigate = useNavigate();

    return (
        <Overlay onClick={onClose}>
            <BottomSheet onClick={(e) => e.stopPropagation()}>
                {isAccountIncomplete ? (
                    <div className="text-container">
                        <h2>Your Personal details are missing</h2>
                        <p>
                            You haven't entered your personal details yet. Please fill them in to
                            proceed.
                        </p>
                        <StyledButton
                            $borderRadius="4px"
                            color={["#436CB2 0%", "#28B7C3 100%"]}
                            onClick={() => navigate(PATH_MY_ACCOUNT)}
                        >
                            Add my personal details
                        </StyledButton>
                    </div>
                ) : (
                    <>
                        <div className="details-container">
                            <h2>Suggestions</h2>
                            <ScrollBox>
                                {_.map(suggestions, (user) => (
                                    <div className="details" key={user.id}>
                                        <span>
                                            <StyledSuggestionButton
                                                type="button"
                                                isSuggestionClicked={
                                                    selectedSuggestion?.id === user.id
                                                }
                                                onClick={() =>
                                                    onSelect({
                                                        first_name: user.first_name,
                                                        last_name: user.last_name,
                                                        phone_number: Number(user.phone_number),
                                                        country_code: user.country_code,
                                                        email: user.email,
                                                        id: user.id,
                                                    })
                                                }
                                            >
                                                <div />
                                            </StyledSuggestionButton>
                                        </span>
                                        <div>
                                            <h1>
                                                {user.first_name} {user.last_name}{" "}
                                                {user.is_primary === 1 && "(you)"}
                                            </h1>
                                            <p>
                                                {user.phone_number},{" "}
                                                {getCountryName(user.country_code)}, {user.email}
                                            </p>
                                        </div>
                                    </div>
                                ))}
                            </ScrollBox>
                        </div>
                        <div className="styled-buttons">
                            <BorderButton
                                $borderRadius="4px"
                                color="transparent"
                                $textColor={theme.colors.main}
                                onClick={onCreateNew}
                            >
                                Create New
                            </BorderButton>
                            <NormalStyledButton
                                $borderRadius="4px"
                                color={["#436CB2 0%", "#28B7C3 100%"]}
                                onClick={onAdd}
                            >
                                Add to booking
                            </NormalStyledButton>
                        </div>
                    </>
                )}
            </BottomSheet>
        </Overlay>
    );
};

const slideUp = keyframes`
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
`;

const Overlay = styled.div`
    display: none;
    ${[breakpoint.breakMobile, breakpoint.breakSmall].map(
        (breakpointFn) => breakpointFn`
    display: block;`,
    )}
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 10;
    cursor: pointer;
`;

const BottomSheet = styled.div`
    display: none;
    ${[breakpoint.breakMobile, breakpoint.breakSmall].map(
        (breakpointFn) => breakpointFn`
        display: block;
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        z-index: 15;
        background: #fff;
        border-top-left-radius: 16px;
        border-top-right-radius: 16px;
        box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
        animation: ${slideUp} 0.3s ease-out;
        padding: 38px 16px 24px 16px;

        .text-container {
            display: flex;
            flex-direction: column;
            gap: 20px;
            text-align: center;
            h2 {
                font-size: 20px;
                font-weight: 600;
            }
        }

        .details-container{
            display: flex;
            flex-direction: column;
            gap: 20px;
            margin-bottom: 30px;
            h2 {
                font-size: 20px;
                font-weight: 600;
            }
            .details {
                display : flex;
                align-items : center;
                gap : 16px;
                div{
                    display : flex;
                    flex-direction : column;
                    gap : 6px;
                    h1{
                        font-size : 24px;
                        font-weight : 600;  
                    }
                    p{
                        font-size : 12px;
                        color : #6E7375;
                    }
                }
            }
            
        }
        .styled-buttons {
            display : flex;
            gap : 14px;
        }
    `,
    )}
`;

const BorderButton = styled(StyledBorderButton)`
    margin-top: 0px;
    padding: 24px 0px;
`;

const NormalStyledButton = styled(StyledButton)`
    margin-top: 0px;
    padding: 25px 0px;
`;

const StyledSuggestionButton = styled.button<StyledSuggestionButtonProps>`
    width: 24px;
    height: 24px;
    padding: 6px;
    border-radius: 50px;
    border: ${(props) => (props.isSuggestionClicked ? "1px solid #7fbfff" : "1px solid #daddde")};
    transition: background-color 0.3s ease;
    cursor: pointer;
    background-color: ${(props) => (props.isSuggestionClicked ? "#7fbfff" : "")};

    div {
        width: 100%;
        height: 100%;
        border-radius: 50px;
        background-color: #fff;
    }
`;

const TravellerPopup = styled.div`
    ${breakpoint.breakOnlyMobile`
        display: none;
    `}
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 15;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const Popup = styled.div`
    background: #fff;
    border-radius: 8px;
`;

const PopupContent = styled.div`
    padding: 54px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
    text-align: center;
    h2 {
        font-size: 24px;
        font-weight: 600;
        margin-bottom: 22px;
    }
    p {
        color: #6e7375;
        font-size: 16px;
        margin-bottom: 22px;
    }
    .styled-buttons {
        display: flex;
        flex-direction: column;
        gap: 14px;
    }
`;

const SuggesstionPopup = styled.div`
    width: 700px;
    padding: 50px 30px;
    .details-container-web {
        display: flex;
        flex-direction: column;
        gap: 20px;
        margin-bottom: 30px;
        h2 {
            font-size: 26px;
            font-weight: 700;
        }
        .details {
            display: flex;
            align-items: center;
            gap: 16px;
            div {
                display: flex;
                flex-direction: column;
                gap: 6px;
                h1 {
                    font-size: 24px;
                    font-weight: 600;
                }
                p {
                    font-size: 12px;
                    color: #6e7375;
                }
            }
        }
    }

    .styled-buttons {
        display: flex;
        gap: 24px;
    }
`;

const ScrollBox = styled.div`
    max-height: 20vh;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 20px;
`;
